"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardEditorContainer_1 = require("../../../../../../shared/components/containers/CardEditorContainer");
var PartnersContentImgEdit = /** @class */ (function (_super) {
    __extends(PartnersContentImgEdit, _super);
    function PartnersContentImgEdit(props) {
        return _super.call(this, props) || this;
    }
    PartnersContentImgEdit.prototype.componentWillMount = function () {
        this.setState({
            title: this.props.fileName,
        });
        this.doReSetRules();
    };
    PartnersContentImgEdit.prototype.doReSetRules = function () {
        this.setState({
            title_rules: { isError: false }
        });
    };
    PartnersContentImgEdit.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.RenameFile(this.props.brand, this.props.dirName, this.props.fileName, this.state.title, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Файл изменен!");
            });
        }
    };
    PartnersContentImgEdit.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((!this.state.title) || (this.state.title.length === 0)) {
            this.setState({ title_rules: { isError: true, errorMessage: "Поле [название] не заполнено!" } });
            return false;
        }
        return true;
    };
    PartnersContentImgEdit.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    PartnersContentImgEdit.prototype.getFormTitle = function () {
        return "Переименовать файл";
    };
    PartnersContentImgEdit.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 300 },
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Название:", placeholder: "Введите название" }, value: this.state.title, onValueChanged: function (newVal) {
                    _this.setState({
                        title: newVal,
                        title_rules: { isError: false }
                    });
                }, required: true, rules: this.state.title_rules }),
            React.createElement(CardRowButtonSet_1.default, { editMode: true, title: { btnEdit: "Сохранить", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    return PartnersContentImgEdit;
}(React.Component));
exports.default = PartnersContentImgEdit;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_images/ui/component/PartnersContentImgEdit.tsx
// module id = 2468
// module chunks = 0